<template>
  <div style="margin-top:10px">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="alias" >
        <el-input v-model="queryParams.alias" :placeholder="$t('app.invoice.form.placeholder.alias')" @keyup.enter.native="search" class="iccid-search-input"
                  clearable></el-input>
      </el-form-item>
      <el-form-item prop="title">
        <el-input v-model="queryParams.title" :placeholder="$t('app.invoice.form.placeholder.title')" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="queryParams.status" filterable :placeholder="$t('app.invoice.form.placeholder.status')" @change="search" clearable multiple>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            :start-placeholder="$t('app.invoice.form.placeholder.startDate')"
            :end-placeholder="$t('app.invoice.form.placeholder.endDate')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">{{ $t('app.invoice.button.search') }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">{{ $t('app.invoice.button.reset') }}</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="mergeInvoice" v-hasPermi="['order:invoice:merge']">
          {{ $t('app.invoice.button.merge') }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData"
              row-key="id"
              :default-expand-all="isExpandAll"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}" border
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" :selectable="handleDisable" v-if="checkPermi(['order:invoice:merge'])"></el-table-column>
      <el-table-column type="index" :label="$t('app.invoice.recordTable.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="alias" :label="$t('app.invoice.recordTable.iccidAgent')" align="center" min-width="200px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" :label="$t('app.invoice.recordTable.invoiceSource')" align="center" width="120px">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.sort == '用户充值'">{{ scope.row.sort }}</el-tag>
          <el-tag type="warning" v-else-if="scope.row.sort == '代理商充值'">{{ scope.row.sort }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="adminShow" prop="appName" :label="$t('app.invoice.recordTable.merchantName')" align="center" width="200px"></el-table-column>
      <el-table-column prop="money" :label="$t('app.invoice.recordTable.amount')" align="center" width="100px"></el-table-column>
      <el-table-column prop="titleType" :label="$t('app.invoice.recordTable.titleType')" align="center" width="110px"></el-table-column>
      <el-table-column prop="type" :label="$t('app.invoice.recordTable.invoiceType')" align="center" min-width="110"></el-table-column>
      <el-table-column prop="invoiceInformation" :label="$t('app.invoice.recordTable.invoiceInfo')" align="center" width="300px">
        <template slot-scope="scope">
          <p class="invoiceInformation-p">{{ $t('app.invoice.recordTable.invoiceTitle') }}：{{ scope.row.title }}</p>
          <p class="invoiceInformation-p">{{ $t('app.invoice.recordTable.taxId') }}：{{ scope.row.ein }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('app.invoice.recordTable.status')" align="center" width="80px">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == '已通过' || scope.row.status == '已寄出'">
            {{ scope.row.status }}
          </el-tag>
          <el-tag type="warning" v-else-if="scope.row.status == '审核中'">{{ scope.row.status }}</el-tag>
          <el-tag type="danger" v-else-if="scope.row.status == '未通过' || scope.row.status == '已驳回'">{{ scope.row.status }}</el-tag>
          <el-tag type="info" v-else-if="scope.row.status == '不开票'">{{ scope.row.status }}</el-tag>
          <el-tag type="primary" v-else>{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('app.invoice.recordTable.applyTime')" align="center" min-width="134px"></el-table-column>
      <el-table-column v-if="adminShow" prop="remark" :label="$t('app.invoice.recordTable.remark')" align="center" width="250px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column :label="$t('app.invoice.recordTable.operation')" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-view" @click="infoRow(scope.row)"
                     v-if='scope.row.show'
                     v-hasPermi="['order:invoice:detail']">{{ $t('app.common.detail') }}
          </el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-download" @click="editRow(scope.row.invoiceUrl)"
                     v-if='scope.row.invoiceUrl && scope.row.invoiceUrl.indexOf("http")!=-1 && scope.row.show'
                     v-hasPermi="['order:invoice:down']">{{ $t('app.common.download') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
  </div>
</template>
<script>
import {invoiceList, invoiceMerge, invoiceStatusAll} from "@/api/api.js";

export default {
  data() {
    return {
      queryParams: {
        alias:undefined,
        title:undefined,
        status:[]
      },
      dateRange: [],
      tableData: [],
      operator: [],
      // 是否展开，默认全部折叠
      isExpandAll: false,
      value: "",
      page: 1,
      pageSize: 20,
      total: 0,
      iccidShow: true,
      mergeIds: []
    }
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    // 根据条件禁用
    handleDisable(row, index) {
      if (row.parentId === null && row.status === "已通过") {
        return true
      } else {
        return false
      }
    },
    // 多选单选的值
    handleSelectionChange(val) {
      let mergeIds = [];
      val.map(item => {
        mergeIds.push(item.id);
      })
      this.mergeIds = mergeIds;
    },
    // 状态转换
    inventoryStatusType(status) {
      let obj =  this.operator.find(v => v.value === status);
      return !!obj? obj.label :'未知';
    },
    // 获取状态
    optStatusAll() {
      invoiceStatusAll({}).then(res => {
        this.operator = res.data.data;
        this.initData();
      })
    },
    // 初始化数据
    initData() {
      let {iccids} = this.queryParams;
      let params = {
        model: {
          ...this.addDateRange(this.queryParams, this.dateRange),
          iccids: iccids ? iccids.replace(/ /g, "\n").split("\n") : [],
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      invoiceList(params).then(res => {
        this.tableData = res.data.data.records;
        this.tableData.map((item, index) => {
          item.appName = item.appName == null ? "-" : item.appName + " (" + item.mchId + ")";
          item.type = item.type === "1" ? "电子普通发票" : "增值税专用发票";
          item.titleType = item.titleType === "1" ? "企业单位" : "个人/事业单位";
          item.status = this.inventoryStatusType(item.status);
          item.ein = item.ein == null ? "-" : item.ein;
          item.createTime = item.createTime.substr(0, 16);
          item.show = true;
          if(item.parentId === -1){
            item.children.map((child, index) => {
              child.appName = child.appName == null ? "-" : child.appName + " (" + child.mchId + ")";
              child.type = child.type === "1" ? "电子普通发票" : "增值税专用发票";
              child.titleType = child.titleType === "1" ? "企业单位" : "个人/事业单位";
              child.status = this.inventoryStatusType(child.status);
              child.ein = child.ein == null ? "-" : child.ein;
              child.createTime = child.createTime.substr(0, 16);
              child.show = false;
            })
          }
        })
        this.total = res.data.data.total
      })
    },
    search() {
      this.page = 1,
          this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },

    // 合并发票
    mergeInvoice() {
      this.$confirm('是否确认合并选中的订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        invoiceMerge(JSON.stringify(this.mergeIds)).then(res => {
          if (res.data.code == 200) {
            this.$message({ type: 'success',message: '重置成功!'});
            this.page = 1,
                this.initData()
          } else {
            this.$message.error(res.data.message);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消合并'
        });
      });
    },
    // 详情跳转
    infoRow(row) {
      this.$router.push('/order/invoiceDetail/' + row.id);
    },
    // 下载发票
    editRow(url) {
      window.open(url);
    },
  },
  created() {
    this.optStatusAll();
  },
  activated() {
    this.initData();
  },
  mounted() {

  },

};
</script>

<style scoped lang="less">
.invoiceInformation-p {
  text-align: left;
}
.iccid-search-input{
  width: 240px;
}


</style>


